import { getUiEventTarget } from '../shadowDom';
import { mountFeatureDot } from '../ui/featureGuideController';
import { PALETTE } from '../designPalette';
import { FOUNDATIONS } from '../designFoundations';
import { CONTROL_PROFILES } from '../controlProfiles';
import { RulerIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../ui/iconDom';
export function mountSpacingInspectorButton(container, appearance = 'toolbar', featureGuides, onToggle) {
    const doc = container.ownerDocument;
    const button = doc.createElement('button');
    button.type = 'button';
    button.dataset.spacingToggle = 'true';
    button.setAttribute('aria-label', 'Spacing');
    button.setAttribute('aria-pressed', 'false');
    button.title = 'Show padding and spacing';
    button.append(createIcon(doc, RulerIcon, 'spacing'));
    const label = doc.createElement('span');
    label.textContent = 'Spacing';
    button.append(label);
    button.style.cssText = `display:inline-flex;align-items:center;justify-content:center;gap:${FOUNDATIONS.space['1h']};flex-shrink:0;height:${CONTROL_PROFILES.app.toolbar.height};box-sizing:border-box;padding:0 ${FOUNDATIONS.space['2h']};border:1px solid ${PALETTE.surface.border};border-radius:${FOUNDATIONS.radius.control};font-family:${FOUNDATIONS.fontFamily.system};font-size:${FOUNDATIONS.fontSize.compact};font-weight:${FOUNDATIONS.fontWeight.medium};line-height:${FOUNDATIONS.lineHeight.body};letter-spacing:${FOUNDATIONS.letterSpacing.normal};cursor:pointer;white-space:nowrap;background:${PALETTE.surface.card};color:${PALETTE.neutral[700]}`;
    if (appearance === 'rail') {
        button.removeAttribute('style');
        button.className = 'oq-sidebar__nav-btn';
        button.querySelector('span').remove();
        button.querySelector('svg').setAttribute('width', '20');
        button.querySelector('svg').setAttribute('height', '20');
    }
    else if (appearance === 'capture') {
        button.removeAttribute('style');
        button.className = 'oq-capture-toolbar__spacing';
        label.remove();
        button.removeAttribute('title');
        button.dataset.tooltip = 'Show padding and spacing';
    }
    let requestedEnable = false;
    let initialized = false;
    const state = (event) => {
        const active = event.detail?.enabled === true;
        const changed = button.getAttribute('aria-pressed') !== String(active);
        button.setAttribute('aria-pressed', String(active));
        if ((initialized || requestedEnable) && changed)
            onToggle?.(active);
        initialized = true;
        if (active && changed && requestedEnable)
            featureGuides?.preferences.track('feature_used', { feature: 'spacing', placement: appearance === 'capture' ? 'capture_toolbar' : appearance });
        requestedEnable = false;
        if (active && featureGuides?.preferences.isUnseen('spacing'))
            featureGuides.preferences.acknowledge('spacing');
        const tooltip = active ? 'Hide padding and spacing · Esc' : 'Show padding and spacing';
        if (appearance === 'capture') {
            button.dataset.tooltip = tooltip;
            return;
        }
        button.title = tooltip;
        if (appearance === 'rail') {
            button.classList.toggle('oq-sidebar__nav-btn--active-cyan', active);
            return;
        }
        button.style.background = active ? PALETTE.primary[50] : PALETTE.surface.card;
        button.style.color = active ? PALETTE.primary[700] : PALETTE.neutral[700];
        button.style.borderColor = active ? PALETTE.primary[400] : PALETTE.surface.border;
    };
    const toggle = (event) => { event.stopPropagation(); requestedEnable = button.getAttribute('aria-pressed') !== 'true'; getUiEventTarget(doc).dispatchEvent(new CustomEvent('oq:spacing-toggle')); };
    for (const type of ['pointerdown', 'mousedown'])
        button.addEventListener(type, event => event.stopPropagation());
    button.addEventListener('click', toggle);
    getUiEventTarget(doc).addEventListener('oq:spacing-state', state);
    container.append(button);
    const dot = featureGuides ? mountFeatureDot(button, 'spacing', featureGuides, () => {
        if (button.getAttribute('aria-pressed') !== 'true')
            button.click();
    }) : undefined;
    getUiEventTarget(doc).dispatchEvent(new CustomEvent('oq:spacing-query'));
    return { destroy() { getUiEventTarget(doc).removeEventListener('oq:spacing-state', state); dot?.destroy(); button.remove(); } };
}
//# sourceMappingURL=inspectorButton.js.map